import {useQuery} from '@tanstack/react-query';
import {AxiosResponse} from 'axios';
import {IApiPaginationResponse} from '../../dto/API.dto';
import {IMediaTrack} from '../../dto/MediaTrack.dto';
import axiosInstance from '../../axiosConfig';

const getMediaTracks = (
  companyId: number,
  specialtyCategoryId: number,
  params: ISpecialtyCategoryMediaTracksQueryParams,
) => {
  return axiosInstance
    .get(
      `v1/company/${companyId}/speciality-category/${specialtyCategoryId}/track`,
      {
        params,
      },
    )
    .then((response: AxiosResponse<IApiPaginationResponse<IMediaTrack[]>>) => {
      return response.data;
    });
};

export type ISpecialtyCategoryMediaTracksQueryParams = {
  per_page: number;
  page?: number;
  search?: string;
};

export const useRqSpecialtyCategoryPaginateMediaTracks = (
  companyId: number = 0,
  specialtyCategoryId: number,
  query: ISpecialtyCategoryMediaTracksQueryParams = {per_page: 10},
  enabled: boolean = true,
) => {
  const params = {...query, page: query.page ? query.page + 1 : 1};
  return useQuery({
    queryKey: [
      `v1/company/${companyId}/speciality-category/${specialtyCategoryId}/track`,
      params,
    ],
    queryFn: () => getMediaTracks(companyId, specialtyCategoryId, params),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: enabled,
  });
};
